import { round } from '../generic';

/**
 * Converts a percentage value to a string
 * E.g:
 * `toPercentageString(0.10) = '10.00%'
 *
 * @param percent - The percent value
 * @param decimalPlaces - The decimal places to display (default=2)
 * @returns - The percentage value as a string
 */
export function toPercentageString(percent: number, decimalPlaces: 'infinity' | number = 2): string {
    // Make sure if the decimal
    if (typeof decimalPlaces === 'number' && decimalPlaces > 20 && decimalPlaces !== Infinity) {
        throw new Error('You cannot round to more than 20 decimal places, unless using infinity');
    }

    let percentFixed = percent;

    if (isNaN(percent)) {
        percentFixed = 0;
    }

    const percentMultiplied = percentFixed * 100;

    if (decimalPlaces === 'infinity' || decimalPlaces === Infinity) {
        return `${percentMultiplied}%`;
    } else if (decimalPlaces <= 0) {
        return `${round(percentMultiplied, decimalPlaces)}%`;
    } else {
        return `${round(percentMultiplied, decimalPlaces).toFixed(decimalPlaces)}%`;
    }
}
